




















































































































import { Component, Watch } from 'vue-property-decorator';
import AccountApi from '@web/services/AccountService';
import {
  FormFieldModel,
  OrganizationSignUpModel,
  signupOrganizationFields,
  signupOrganizationFieldsValidation,
  organizationSignUpModel,
} from '@shared/models/LoginModels';
import { EFieldNames } from '@shared/models/Enums/EFieldNames';
import { EModes } from '@shared/models/Enums/EModes';
import Layout from '@shared/views/LoginLayouts/Layout.abstract';

const api = new AccountApi();

enum Steps {
  first,
  second,
  last,
}

@Component
export default class SignupOrganization extends Layout {
  public mode = EModes.Organization;

  public Steps = Steps;

  validations = {
    model: signupOrganizationFieldsValidation,
  };

  public fields = signupOrganizationFields;

  public model: OrganizationSignUpModel = { ...organizationSignUpModel };

  public image = () => require('@shared/assets/Organization.svg');

  public currentStep = Steps.first;

  public firstStepFieldsList: EFieldNames[] = [
    EFieldNames.FirstName,
    EFieldNames.LastName,
    EFieldNames.Organization,
    EFieldNames.OrganizationType,
  ];

  public secondStepFieldsList: EFieldNames[] = [
    EFieldNames.Address,
    EFieldNames.Country,
    EFieldNames.City,
    EFieldNames.State,
    EFieldNames.Zip,
  ];

  public lastStepFieldsList: EFieldNames[] = [
    EFieldNames.Email,
    EFieldNames.Phone,
    EFieldNames.Note,
    EFieldNames.Policy,
  ];

  public loading = false;

  get fieldsSet(): { [key: string]: FormFieldModel } {
    const fieldNames: () => EFieldNames[] = () => {
      switch (this.currentStep) {
        case Steps.first:
          return this.firstStepFieldsList;
        case Steps.second:
          return this.secondStepFieldsList;
        default:
          return this.lastStepFieldsList;
      }
    };

    return Object.fromEntries(
      fieldNames().map((name: string) => [name, this.fields[name]])
    );
  }

  get isFirstStepCompleted() {
    return this.checkValidation(this.firstStepFieldsList);
  }

  get isSecondStepCompleted() {
    return this.checkValidation(this.secondStepFieldsList);
  }

  next() {
    if (this.currentStep === Steps.first) {
      this.firstStepFieldsList.forEach((field: string) => {
        const vField = this.$v.model[field];
        if (vField && vField.$touch) {
          vField.$touch();
        }
      });
      if (!this.isFirstStepCompleted) {
        return;
      }
    }
    if (this.currentStep === Steps.second) {
      this.secondStepFieldsList.forEach((field: string) => {
        const vField = this.$v.model[field];
        if (vField && vField.$touch) {
          vField.$touch();
        }
      });
      if (!this.isSecondStepCompleted) {
        return;
      }
    }
    this.$v.model.$reset();

    this.currentStep += 1;
  }

  back() {
    if (this.currentStep === Steps.first) {
      this.$router.go(-1);
      return;
    }
    this.$v.model.$reset();
    this.currentStep -= 1;
  }

  signup() {
    this.$v.model.$touch();

    if (this.isFormInvalid) return;

    this.loading = true;
    api.accountOrganizationRegistration(this.model).finally(() => {
      this.loading = false;
    });
  }

  @Watch(`model.${EFieldNames.Policy}`)
  watchPolicy() {
    if (!this.model[EFieldNames.Policy]) {
      this.model[EFieldNames.Policy] = null;
    }
  }
}
